/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-all-property-notice-to-quit'),
	    dataTables_buttons = [
		    {
			    extend: 'csv',
			    text: 'Export as CSV',
			    exportOptions: {
				    columns: [0, 1, 2]
			    },
		    },
		    {
			    extend: 'pdf',
			    text: 'Export as PDF',
			    exportOptions: {
				    columns: [0, 1, 2]
			    },
			    orientation: 'landscape'
		    },
		    {
			    extend: 'print',
			    text: 'Print table',
			    exportOptions: {
				    columns: [0, 1, 2]
			    }
		    },
		    {
			    extend: 'colvis'
		    }
	    ],
        dt;

    dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [ 30, 10, 25, 50, 75, 100],
	    "ajax": {
		    "url": helper.getOrigin() + "/api/properties/notice-to-quit",
		    "method": 'POST',
		    "data": function ( d ) {
		    }
	    },
        "bAutoWidth" : false,
	    "buttons": dataTables_buttons,
        "order": [[ 2, "desc" ]],
        "columns": [
            {data: 'creator', name: 'creator'},
            {data: 'propertyName', name: 'propertyName'},
            {data: 'date_notice', name: 'date_notice'},

        ]
    });

});
